import { FACET_HOME_FEATURES_MAPPING } from './constants/';
import { constantize } from "shared_critical/format_helper";

export const FACET_PETS = {
  'cats': 'Cats OK',
  'dogs': 'Dogs OK',
  'no_pet_policy': 'No Policy',
  'no_pets_allowed': 'No Pets'
};

export const FACET_SHOW_LISTINGS_MAPPING = {
  'nl': 'New Listings',
  'nc': 'New Construction',
  'oh': 'Open Houses',
  'pr': 'Price Reduced'
};

MOVE.SRP.CONSTANTS = constantize({
  FACET_PETS,
  FACET_SHOW_LISTINGS_MAPPING,
  FACET_HOME_FEATURES_MAPPING
});



// WEBPACK FOOTER //
// ./srp/constants.js